(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';

function _mapLeukocytes(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref = valueQuantity || {},
      value = _ref.value,
      unit = _ref.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    leukocytes: "".concat(value, " ").concat(unit)
  };
}

function _mapHemoglobin(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref2 = valueQuantity || {},
      value = _ref2.value,
      unit = _ref2.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    hemoglobin: "".concat(value, " ").concat(unit)
  };
}

function _mapPlatelets(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref3 = valueQuantity || {},
      value = _ref3.value,
      unit = _ref3.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    platelets: "".concat(value, " ").concat(unit)
  };
}

function _mapLymphocytes(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref4 = valueQuantity || {},
      value = _ref4.value,
      unit = _ref4.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    lymphocytes: "".concat(value, " ").concat(unit)
  };
}

function _mapNeutrophils(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref5 = valueQuantity || {},
      value = _ref5.value,
      unit = _ref5.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    neutrophils: "".concat(value, " ").concat(unit)
  };
}

function _mapEosinophils(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref6 = valueQuantity || {},
      value = _ref6.value,
      unit = _ref6.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    eosinophils: "".concat(value, " ").concat(unit)
  };
}

function _mapBasophils(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref7 = valueQuantity || {},
      value = _ref7.value,
      unit = _ref7.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    basophils: "".concat(value, " ").concat(unit)
  };
}

function _mapMonocytes(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref8 = valueQuantity || {},
      value = _ref8.value,
      unit = _ref8.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    monocytes: "".concat(value, " ").concat(unit)
  };
}

function _mapObservations(observations, panelObservation) {
  var labsData = {};
  observations.forEach(function (observation) {
    var _ref9 = observation && observation.code || {},
        coding = _ref9.coding;

    var _ref10 = coding && !!coding.length && coding[0] || {},
        code = _ref10.code,
        system = _ref10.system;

    if (!code || !system) {
      return;
    }

    if (!observation.effectiveDateTime) {
      return;
    }

    labsData.idMap = labsData.idMap || {};
    labsData.date = labsData.date || moment(observation.effectiveDateTime).local().format("ddd, MMM D, YYYY, HH:mm"); // Leukocytes

    if (system === 'http://loinc.org' && code === '6690-2') {
      labsData.idMap.leukocytes = observation.id;
      labsData = Object.assign({}, labsData, _mapLeukocytes(observation));
    } // Hemoglobin


    if (system === 'http://loinc.org' && code === '718-7') {
      labsData.idMap.hemoglobin = observation.id;
      labsData = Object.assign({}, labsData, _mapHemoglobin(observation));
    } // Platelets


    if (system === 'http://loinc.org' && code === '32623-1') {
      labsData.idMap.platelets = observation.id;
      labsData = Object.assign({}, labsData, _mapPlatelets(observation));
    } // Lymphocytes


    if (system === 'http://loinc.org' && code === '26474-7') {
      labsData.idMap.lymphocytes = observation.id;
      labsData = Object.assign({}, labsData, _mapLymphocytes(observation));
    } // Neutrophils


    if (system === 'http://loinc.org' && code === '26499-4') {
      labsData.idMap.neutrophils = observation.id;
      labsData = Object.assign({}, labsData, _mapNeutrophils(observation));
    } // Eosinophils


    if (system === 'http://loinc.org' && code === '26449-9') {
      labsData.idMap.eosinophils = observation.id;
      labsData = Object.assign({}, labsData, _mapEosinophils(observation));
    } // Basophils


    if (system === 'http://loinc.org' && code === '26444-0') {
      labsData.idMap.basophils = observation.id;
      labsData = Object.assign({}, labsData, _mapBasophils(observation));
    } // Monocytes


    if (system === 'http://loinc.org' && code === '26484-6') {
      labsData.idMap.monocytes = observation.id;
      labsData = Object.assign({}, labsData, _mapMonocytes(observation));
    } // Set Short Blood Count Panel id if it belongs to one


    if (panelObservation && panelObservation.hasMember && panelObservation.hasMember.some(function (hm) {
      return hm.reference === "Observation/".concat(observation.id);
    })) {
      labsData.idMap.panel = panelObservation.id;
    }
  });

  if (!Object.keys(labsData).length) {
    return null;
  }

  return labsData;
}

export default function mapFromFHIR(observationBundleEntry) {
  // Group observations by effectiveDateTime
  var observationsByDateTime = observationBundleEntry.reduce(function (acc, obs) {
    var _ref11 = obs || {},
        resource = _ref11.resource;

    var _ref12 = resource || {},
        effectiveDateTime = _ref12.effectiveDateTime;

    if (!effectiveDateTime) {
      return acc;
    }

    acc[effectiveDateTime] = acc[effectiveDateTime] || [];
    acc[effectiveDateTime].push(resource);
    return acc;
  }, {});
  var labsDataList = []; // Find blood count panel and add its id into each labs data

  Object.values(observationsByDateTime).forEach(function (observations) {
    // Get labs panels
    var labsPanelObservations = observations.filter(function (obs) {
      var _ref13 = obs && obs.code || {},
          coding = _ref13.coding;

      var _ref14 = coding && !!coding.length && coding[0] || {},
          code = _ref14.code,
          system = _ref14.system; //  Short blood count panel - Blood


      return system === 'http://loinc.org' && code === '55429-5';
    });

    if (labsPanelObservations && labsPanelObservations.length) {
      // Get individual labs from labs panel
      labsPanelObservations.forEach(function (labsPanelObservation) {
        var labsObservations = observations.filter(function (obs) {
          return !labsPanelObservation || labsPanelObservation.hasMember.some(function (hm) {
            return hm.reference === "Observation/".concat(obs.id);
          });
        });

        var labsData = _mapObservations(labsObservations, labsPanelObservation);

        if (!labsData) {
          return;
        }

        labsDataList.push(labsData);
      });
    } else {
      // Get individual labs directly since there is no panel
      var labsData = _mapObservations(observations, null);

      if (!labsData) {
        return;
      }

      labsDataList.push(labsData);
    }
  });
  return labsDataList;
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_mapLeukocytes, "_mapLeukocytes", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapHemoglobin, "_mapHemoglobin", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapPlatelets, "_mapPlatelets", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapLymphocytes, "_mapLymphocytes", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapNeutrophils, "_mapNeutrophils", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapEosinophils, "_mapEosinophils", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapBasophils, "_mapBasophils", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapMonocytes, "_mapMonocytes", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapObservations, "_mapObservations", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(mapFromFHIR, "mapFromFHIR", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapFromFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();